import {
  Card,
  CardActions,
  CardContent,
  Skeleton,
  styled,
} from "@mui/material";

export function LayerCardSkeleton() {
  return (
    <StyledCard>
      <Skeleton variant="rectangular" height="190px" />
      <CardContent>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Skeleton width="95px" height="30px" />
      </CardActions>
    </StyledCard>
  );
}

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
